module.exports = __webpack_public_path__ + "static/img/defeng.adc1e61.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img2/defeng.jpg
// module id = 8Dtt
// module chunks = 3